import { render, staticRenderFns } from "./ResourceExchange.vue?vue&type=template&id=7e419148"
import script from "./ResourceExchange.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceExchange.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports